import { useEffect, useState } from 'react'
import { setDialog } from '../app/dialog'
import { useLazyIsFileSharableQuery } from '../app/appApiQueries'
import {
  useAppDispatch,
  useSelectOrigin,
  useSelectRunningContext,
} from './useRTK'
import { App, setIsGeneralSpinner } from '../app/root'

export const useSetDialog = (app: App, fileUrl: string | undefined) => {
  const dispatch = useAppDispatch()
  const runningContext = useSelectRunningContext()
  const [trigger, { data, isFetching, fulfilledTimeStamp }] =
    useLazyIsFileSharableQuery()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [lastTimeStamp, setLastTimeStamp] = useState<number>(0)

  const openLink = async (url: string) => {
    await zoomSdk.openUrl({ url }).catch(() => {
      //swallow
    })
  }
  const origin = useSelectOrigin()

  useEffect(() => {
    // if we aren't fetching
    const handleShareableData = async () => {
      if (
        !isFetching &&
        // and we have a response
        data?.shareable !== undefined &&
        // and we have a new fulfilled timestamp
        fulfilledTimeStamp &&
        // and we are a new timestamp (new fetch)
        fulfilledTimeStamp > lastTimeStamp
        // and we are a new timestamp (new fetch)
      ) {
        if (data.shareable) {
          let collaborateContext = null

          try {
            collaborateContext = await zoomSdk.getCollaborateContext()
          } catch (e) {
            // Do nothing
          }
          if (
            runningContext === 'inCollaborate' ||
            (runningContext === 'inMeeting' &&
              collaborateContext?.isActiveCollaboration)
          ) {
            dispatch(setDialog({ type: 'collaborationNoShare' }))
          } else if (runningContext === 'inMeeting') {
            if (app === 'Google')
              dispatch(setDialog({ type: 'fileShareGoogle' }))
            else dispatch(setDialog({ type: 'fileShareMS' }))
          } else if (runningContext === 'inChat' && app === 'Google') {
            if (fileUrl) openLink(fileUrl)
            // ============================= Start V3 =============================
            // Delete this last 'else if' to go to back to native collaboration
          } else if (runningContext === 'inChat' && app === 'Microsoft') {
            if (fileUrl) openLink(fileUrl)
          }
          // ============================= End V3 =============================
        } else dispatch(setDialog({ type: 'noShare' }))
        setLastTimeStamp(fulfilledTimeStamp)
      }
    }
    handleShareableData()
  }, [
    data?.shareable,
    dispatch,
    fulfilledTimeStamp,
    isFetching,
    runningContext,
    lastTimeStamp,
    app,
    fileUrl,
    origin,
  ])

  useEffect(() => {
    if (isFetching) {
      dispatch(setIsGeneralSpinner(true))
    } else dispatch(setIsGeneralSpinner(false))
  }, [dispatch, isFetching])

  return trigger
}
